module.exports = __webpack_public_path__ + "static/media/logo.c786483e.gif";